import React from 'react';
import { Container, Section, SectionHeader } from '../../common';

const MapFull = ({ sanity, page }) => {
  const { gbp } = page;
  const { colors, map } = sanity;

  return (
    <Section
      idName="map-full"
      bgColor={colors?.neutral?.light}
      h2Color={colors?.neutral?.darker}
    >
      <Container>
        <SectionHeader
          sanity={sanity}
          tagline={gbp?.name}
          headline={map?.header?.headline}
          description={map?.header?._rawDescription}
        />
        <div className="h-96">
          <iframe
            src={gbp?.gbpEmbed}
            title="McTernan Construction is a general contractor and construction company located in Middleborough, MA that provides residential construction services in the South Shore, Cape Cod, and Southeastern Massachusetts areas. We specialize in home renovations, kitchen and bathroom remodeling, and custom home building. If you live in Plymouth County, Barnstable County, Bristol County, or Norfolk County and are looking for a reliable and experienced general contractor, contact us today to schedule a consultation."
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          />
        </div>
      </Container>
    </Section>
  );
};

MapFull.displayName = 'MapFull';

export { MapFull };
